import { render, staticRenderFns } from "./ColoredTag.vue?vue&type=template&id=6117ee70&scoped=true"
import script from "./ColoredTag.vue?vue&type=script&lang=js"
export * from "./ColoredTag.vue?vue&type=script&lang=js"
import style0 from "./ColoredTag.vue?vue&type=style&index=0&id=6117ee70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6117ee70",
  null
  
)

export default component.exports